import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PERFIL_COPY } from '../../../data/perfil-microempresario.content';
import { AnalyticsTagService } from 'src/app/services/analytics-tag.service';

/**
 * Modal al completar el perfil (100 %): pasos siguientes + Revisar / Enviar.
 */
@Component({
  selector: 'app-perfil-enviar-modal',
  templateUrl: './perfil-enviar-modal.component.html',
  styleUrls: ['./perfil-enviar-modal.component.scss'],
  standalone: false,
})
export class PerfilEnviarModalComponent {
  @Input() open = false;
  @Input() enviando = false;

  @Output() closed = new EventEmitter<void>();
  @Output() revisar = new EventEmitter<void>();
  @Output() enviar = new EventEmitter<void>();

  readonly copy = PERFIL_COPY.modalEnviar;

  constructor(private readonly analyticsTag: AnalyticsTagService) {}

  onClose(): void {
    if (this.enviando) {
      return;
    }
    this.closed.emit();
  }

  onRevisar(): void {
    if (this.enviando) {
      return;
    }
    this.analyticsTag.trackCtaClick({
      ctaLabel: this.copy.ctaRevisar,
      ctaSection: 'perfil-enviar-modal',
      ctaComponent: 'perfil-enviar-modal',
      ctaElementId: 'btn-perfil-enviar-revisar',
      hu: '8099',
    });
    this.revisar.emit();
  }

  onEnviar(): void {
    if (this.enviando) {
      return;
    }
    this.analyticsTag.trackCtaClick({
      ctaLabel: this.copy.ctaEnviar,
      ctaSection: 'perfil-enviar-modal',
      ctaComponent: 'perfil-enviar-modal',
      ctaElementId: 'btn-perfil-enviar-solicitud',
      hu: '8099',
    });
    this.enviar.emit();
  }

  onBackdrop(event: MouseEvent): void {
    if (this.enviando) {
      return;
    }
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }
}
